<template>
  <v-container class="col-12">
    <v-card class="pa-4">
      <v-row class="mx-0">

        <v-text-field
          class="col-2"
          label="Search"
          v-model="searchStr"
          style="min-width: 300px; max-width: 300px"
          hide-details
        />
        <select-project
          v-model="project"
          class="col-1"
          style="min-width: 250px; max-width: 250px"
        ></select-project>
        <date-picker
          v-model="from"
          label="Date From"
          style="max-width: 140px"
        />

        <date-picker
          v-model="to"
          label="Date To"
          style="max-width: 140px"
        />

        <v-btn color="info" v-on:click="search" class="mt-3" :disabled="loading" :loading="loading">Search</v-btn>
      </v-row>
    </v-card>


    <v-card class="pa-0 mt-4">
      <v-data-table
        class="payment-handler-dt"
        :loading="loading"
        :server-items-length="total"
        :headers="headers"
        :options.sync="options"
        :items="items"
        sort-by="created"
        sort-desc
        item-key="account_transaction_id"
        :items-per-page="-1"
        style="z-index: 0; position: relative;"
        hide-default-footer
      >
        <template v-slot:item.login="{ item, header }">
          <a :href="'/user-management/' + item.login " target="_blank">{{ item.login }}</a>
        </template>
        <template v-slot:item.account_id="{ item, header }">
          <a :href="'/user-management/' + item.login " target="_blank">{{ item.account_id }}</a>
        </template>
        <template v-slot:item.created="{ item }">
          <div style="min-width: 150px;">
            {{ item.created }}
          </div>
        </template>
        <template v-slot:item.updated="{ item }">
          <div style="min-width: 150px;">
            {{ item.updated }}
          </div>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<style>

</style>

<script>

  import { cloneDeep, map, startCase } from 'lodash'
  import moment from 'moment'
  import { API } from '@/utils/api'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'
  import DatePicker from '@/components/core/DatePicker/DatePicker.vue'

  export default {
    components: { SelectProject, DatePicker },

    props: [ 'title' ],
    data: () => ({
      from: moment().subtract(7, 'days').format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD'),
      expanded: [],
      headers: [
        { text: 'Created', value: 'created', 'class': 'nowrap' },
        { text: 'AccountID', value: 'account_id', sortable: false, 'class': 'nowrap' },
        { text: 'Alias', value: 'alias', 'class': 'nowrap' },
        { text: 'Amount', value: 'amount', 'class': 'nowrap' },
        { text: 'Currency', value: 'currency', 'class': 'nowrap' },
        { text: 'In EUR', value: 'amount_eur', 'class': 'nowrap' },
        { text: 'Paymethod', value: 'paymethod', 'class': 'nowrap' },
        { text: 'Paysystem', value: 'paysystem', 'class': 'nowrap' },
        { text: 'Status', value: 'status', 'class': 'nowrap' },
        { text: 'Type', value: 'type', 'class': 'nowrap' },
        { text: 'Account', value: 'account', 'class': 'nowrap' },
        { text: 'Description', align: 'left', sortable: false, value: 'comment', 'class': 'nowrap' },
      ],
      project: null,
      loading: false,
      items: [],
      itemsInit: [],
      options: {},
      searchStr: '',
      total: 0,
    }),

    watch: {},

    methods: {

      startCase: (k) => startCase(k),

      search: function () {
        this.loading = true

        API.call('/$v/payment_handler/find_transaction.json', {
          from: this.from,
          to: this.to,
          search: this.searchStr
        }, null, this.project).then(resp => {

          this.total = resp.total
          this.items = cloneDeep(resp.data)
          this.itemsInit = cloneDeep(resp.data)

          return resp.data
        }).catch(e => {
        }).finally(() => {
          this.loading = false
        })

      },
    },
  }
</script>
